import { createColumnHelper } from "@tanstack/react-table";
import { StatusBadge } from "../ui/status-badge";
import type { User } from "../../types/api";

const col = createColumnHelper<User>();

function formatDate(dateString: string | null) {
  if (!dateString) return "Never";
  return new Date(dateString).toLocaleDateString("en-AU", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

export const userColumns = [
  col.accessor("email", {
    header: "Email",
    cell: (info) => (
      <span className="font-medium">{info.getValue()}</span>
    ),
    meta: { label: "Email" },
  }),
  col.accessor("name", {
    header: "Name",
    meta: { label: "Name" },
  }),
  col.accessor("role", {
    header: "Role",
    cell: (info) => {
      const role = info.getValue();
      const variants: Record<User["role"], "info" | "success" | "warning" | "neutral"> = {
        Admin: "warning",
        Editor: "info",
        Manager: "success",
        Viewer: "neutral",
        External: "neutral",
      };
      return <StatusBadge variant={variants[role]}>{role}</StatusBadge>;
    },
    meta: { label: "Role" },
  }),
  col.accessor("registration_status", {
    header: "Status",
    cell: (info) => {
      const status = info.getValue();
      const statusMap: Record<User["registration_status"], string> = {
        active: "active",
        pending_approval: "pending",
        invited: "invited",
        disabled: "disabled",
      };
      const display =
        status === "pending_approval"
          ? "Pending"
          : status.charAt(0).toUpperCase() + status.slice(1);
      return <StatusBadge status={statusMap[status] as any}>{display}</StatusBadge>;
    },
    meta: { label: "Status" },
  }),
  col.accessor("last_login", {
    header: "Last Login",
    cell: (info) => formatDate(info.getValue()),
    meta: { label: "Last Login" },
  }),
];
